import styled from 'styled-components';
import Typography from '~components/dumbs/Typography';

export const Error = styled(Typography).attrs({ as: 'p' })`
  color: ${({ theme }) => theme.color.text.danger.default};
  margin-top: ${({ theme }) => theme.spacing.km1};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  font-size: ${({ theme }) => theme.font.size.m2};
  letter-spacing: -0.03em;
`;
